import React from 'react';
import PropTypes from 'prop-types';

const CONFIG = require('../../../config.json');

const RightMenu = ({ handleItemClick, handleMouseOut }) => {
  const output = [];
  for (const flag of CONFIG.flags) {
    output.push(
      <div className="right-menu" key={flag.country}>
        <img src={flag.image} className="flag" alt="logo" onClick={() => handleItemClick(flag.country)} onMouseOver={() => handleItemClick(flag.country)} onMouseOut={() => handleMouseOut()} />
        <span className="tooltiptext">{flag.name}</span>
      </div>
    );
  }
  return (
    <div className="right-menu-container">
      {output}
    </div>
  );
};

RightMenu.propTypes = {
  handleItemClick: PropTypes.func,
  handleMouseOut: PropTypes.func,
};

export default RightMenu;



// WEBPACK FOOTER //
// ./scripts/components/RightMenu.jsx